import api from '../../../constants/api';
import { getEndOfDay, getStartOfDay } from '../../../constants/DateUtil';
import { getStringFromObject } from '../../../constants/lodashUtils';
import { isObjectValidAndNotEmpty } from '../../../constants/nullCheckUtils';
import { COMBINEMODE, generateObjectWithCriteriaMode, getCombined } from '../../../sagas/util';

export const invoiceStates = {
    PAID: {
        value: 'paid',
        label: 'Paid',
    },
    OPEN: {
        value: 'open',
        label: 'Open',
    },
    DRAFT: {
        value: 'draft',
        label: 'Draft',
    },
};

export const ISSUE_INVOICE_DATE_FILTERS = {
    TODAY: 'Today',
    YESTERDAY: 'Yesterday',
    LAST_7_DAYS: 'Past 7 Days',
    LAST_10_DAYS: 'Past 10 Days',
    LAST_30_DAYS: 'Past 30 Days',
    LAST_60_DAYS: 'Past 60 Days',
    LAST_90_DAYS: 'Past 90 Days',
    LAST_180_DAYS: 'Past 180 Days',
};

export const ISSUE_INVOICE_STATE_FILTERS = [
    { key: 'draft', value: 'Draft' },
    { key: 'paid', value: 'Paid' },
    { key: 'open', value: 'Open' },
];

export const payerTypes = {
    COMPANY: {
        value: 'CREDIT',
        label: 'Company',
    },
    INSURANCE: {
        value: 'INSURANCE',
        label: 'Insurance',
    },
    CORPORATE: {
        value: 'CORPORATE',
        label: 'Corporate',
    },
};

export const ISSUE_INVOICE_TABLE_FILTER = [
    {
        name: 'datePeriod',
        type: 'dateRange',
        label: 'Period',
        showOnTop: true,
        grid: 3,
        valueField: 'key',
        disableClear: true,
        options: Object.keys(ISSUE_INVOICE_DATE_FILTERS).map(aPeriod => ({
            key: aPeriod,
            value: ISSUE_INVOICE_DATE_FILTERS[aPeriod],
        })),
        defaultOption: {
            key: 'LAST_7_DAYS',
            value: 'Past 7 Days',
        },
        searchConstructFields: {},
    },
    {
        name: 'res_partner.id',
        type: 'autocomplete',
        label: 'Payer',
        valueField: 'id',
        disableClear: true,
        dataSourceConfig: {
            text: 'name',
            value: 'id',
        },
        dataSourceApi: api.SEARCH.PAYOR,
        searchConstructFields: {
            name: 'res_partner.id',
            filterOperation: '=',
        },
    },
    {
        name: 'state',
        type: 'select',
        label: 'State',
        valueField: 'key',
        makeTitleCase: true,
        disableClear: true,
        multiple: true,
        options: ISSUE_INVOICE_STATE_FILTERS,
        searchConstructFields: {
            name: 'account_invoice.state',
            filterOperation: '=',
        },
    },
];

export const createSearchConstructForIssueInvoice = (filters) => {
    let searchConstruct = null;
    const datePeriod = getStringFromObject('datePeriod', filters);

    if (isObjectValidAndNotEmpty(datePeriod)) {
        const {
            startDate,
            endDate,
        } = datePeriod;
        if (startDate && endDate) {
            searchConstruct = getCombined(
                searchConstruct,
                COMBINEMODE.AND,
                getCombined(
                    generateObjectWithCriteriaMode(
                        'account_invoice.createDate',
                        getStartOfDay(startDate).getTime(),
                        '>=',
                    ),
                    COMBINEMODE.AND,
                    generateObjectWithCriteriaMode(
                        'account_invoice.createDate',
                        getEndOfDay(endDate).getTime(),
                        '<=',
                    ),
                ),
            );
        } else if (startDate) {
            searchConstruct = getCombined(
                searchConstruct,
                COMBINEMODE.AND,
                generateObjectWithCriteriaMode('account_invoice.createDate', getStartOfDay(startDate).getTime(), '>='),
            );
        } else if (endDate) {
            searchConstruct = getCombined(
                searchConstruct,
                'AND',
                generateObjectWithCriteriaMode('account_invoice.createDate', getEndOfDay(endDate).getTime(), '<='),
            );
        }
    }

    if (isObjectValidAndNotEmpty(filters)) {
        const searchText = getStringFromObject('searchText', filters);
        const textToSearch = (searchText || '').trim();
        if (textToSearch) {
            const searchTextConstruct = generateObjectWithCriteriaMode('account_invoice.number', searchText, ':');
            searchConstruct = getCombined(searchConstruct, COMBINEMODE.AND, searchTextConstruct);
        }
    }

    return searchConstruct;
};
